import { Tab, Tabs } from "@nextui-org/react";
import TransactionList from "./transactionTable";
import { TransactionTypeEnum } from "./types";

const TransactionModuleTabs = () => {
  return (
    <div className="flex w-full flex-col justify-evenly">
      <Tabs
        variant="underlined"
        aria-label="Player Module"
        className="w-full justify-start"
        classNames={{
          tabList: ["overflow-x-auto text-[#FFFFFF80]"],
          cursor: "user-module-selected",
          tabContent:
            "text-base font-bold group-data-[selected=true]:text-[#FFFFFF]",
        }}
      >
        <Tab key="deposit" title="Deposit">
          <TransactionList transactionType={TransactionTypeEnum.DEPOSIT} />
        </Tab>
        <Tab key="withdraw" title="Withdraw">
          <TransactionList transactionType={TransactionTypeEnum.WITHDRAW} />
        </Tab>
        <Tab key="rakeback" title="Cash Back">
          <TransactionList transactionType={TransactionTypeEnum.RAKEBACK} />
        </Tab>
        <Tab key="dex" title="Dex">
          <TransactionList transactionType={TransactionTypeEnum.DEX} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default TransactionModuleTabs;
